/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 4/17/13
 * Time: 10:39 AM
 * To change this template use File | Settings | File Templates.
 */

/*
 Just hold the logic for building the route names
 */
define(function (require) {
    "use strict";

    var Logger = require("logger");

    var RouteNameBuilder = (function () {
        var ver = "0.1";

        //context logger
        var logger = Logger.getLogger("LEFramework");

        var delimiter = "!";

        var assembleName = function (prefix, route) {
            var assembledName = route && "" !== route ? route : prefix;
            if (prefix && "" !== prefix && route && "" !== route) {
                if(route.indexOf(prefix + delimiter) !== 0){
                    assembledName = prefix + delimiter + route;
                }
            }
            return assembledName;
        };

        var parseName = function (name, prefix) {

            var parsedName = {
                prefix:"",
                route:""
            };

            var ind = name.indexOf(delimiter);

            if (-1 === ind) {
                if (prefix) {
                    parsedName.prefix = name;
                } else {
                    parsedName.route = name;
                }
            } else {
                parsedName.prefix = name.substring(0, ind);
                parsedName.route = name.substring(ind + delimiter.length);
            }

            return parsedName;
        };

        var getRouteDelimiter = function() {
            return delimiter;
        };

        var getRoutePrefix = function (name) {
            return parseName(name, true).prefix;
        };

        var getRoute = function (name) {
            return parseName(name).route;
        };

        return {
            assembleName:assembleName,
            parseName:parseName,
            getRoutePrefix:getRoutePrefix,
            getRoute:getRoute,
            getRouteDelimiter:getRouteDelimiter,
            version:function () {
                logger.info("routeNameBuilder.js version " + ver);
            }
        };

    }());

    return RouteNameBuilder;
});
